import React from "react";
import { connect } from 'react-redux'
import { compose } from 'redux'
import { duckify, filterDuck, singleDuck } from '../../utils/duckify'
import { flashMessages, modals, schoolYears, users } from '../../ducks'
import ModalRoot from "../ModalRoot";
import ModalComponent from "../ModalComponent";

import SchoolYearTable from "./SchoolYearTable";

const SchoolYearsWrapper = ({ currentUser, schoolYears, dispatch }) => {
  const activeSchoolYears = schoolYears.filter(schoolYear => !schoolYear.archived)
  const archivedSchoolYears = schoolYears.filter(schoolYear => schoolYear.archived)

  return (
    <div className="school-year-wrapper">
      <ModalRoot modals={{ ConfirmArchiveSchoolYear }} />
      <div className="active-school-years">
        <h3>Active Terms</h3>
        <SchoolYearTable
          schoolYears={activeSchoolYears}
          currentUser={currentUser}
          archived={false}
        />
      </div>

      {archivedSchoolYears.length > 0 && (
        <div className="archived-school-years">
          <h3>Archived Terms</h3>
          <SchoolYearTable
            schoolYears={archivedSchoolYears}
            currentUser={currentUser}
            archived={true}
          />
        </div>
      )}
    </div>
  )
}

const ConfirmArchiveSchoolYear = connect()(({ dispatch, schoolYear, archived, processing = false }) => {
  return (
    <ModalComponent title={archived ? 'Restore Term' : 'Archive Term'} id={archived ? 'restore' : 'archive'}
      buttons={[
        <button className="btn btn-danger"
          disabled={processing}
          onClick={() => {
            dispatch(modals.actions.update({ processing: true }))
            dispatch(schoolYears.actions.update(schoolYear))
              .then(() => dispatch(modals.actions.hide()))
              .then(() => dispatch(schoolYears.actions.markDirty()))
              .then(() => dispatch(flashMessages.actions.show({
                type: 'success',
                message: `Term ${schoolYear.name} has been successfully ${archived ? 'restored' : 'archived'}.`,
                dismissible: true,
              })))
              .catch(() => dispatch(modals.actions.show('UnexpectedError')))
          }}>{processing ? 'Processing...' : archived ? 'Restore' : 'Archive'}</button>
      ]}
    >
      <p>Are you sure you want to {archived ? 'restore' : 'archive'} the term {schoolYear.name}? {archived}</p>
    </ModalComponent>
  )
})

const mapDucksToProps = () => ({
  currentUser: singleDuck(users, 'current'),
  schoolYears: filterDuck(schoolYears, { include_collection_attrs: true }),
})

export default compose(
  duckify(mapDucksToProps, () => ({}), () => ({}))
)(SchoolYearsWrapper)
